// globals
class History {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const grayLineHeight = document.querySelector(".gray-line").offsetHeight
    const redLine = document.querySelector(".red-line")
    let percentage;


    gsap.to('.js-target', {

      scrollTrigger: {
        trigger: '.js-redLine-start',
        start: 'top =+60',
        end: grayLineHeight,
        // markers: true,
        scrub: true,
        onEnter: () => {
          redLine.style.height = "0px"
        },
        onUpdate:(self)=>{
          percentage = self.progress.toLocaleString( undefined, { maximumFractionDigits:3 })*100;
          redLine.style.height = `${percentage}%`
        }
      }
    });


    const yearDots = document.querySelectorAll(".js-list-content")
    const yearMenu = document.querySelectorAll(".year-time");


    // 対象のエレメント
    // optionは省略可能、初期値は以下のようになります。
    const option = {
        root: null,
        rootMargin: "-100px",
        threshold: [0]
    };

    yearDots.forEach((dot,i) => {
      // 交差した際の処理を記載
      const callback = function (entries, observer) {
          entries.forEach(function (entry) {
            // 交差している場合はtrue
            if (entry.isIntersecting) {
                  // 処理実行
                  // 処理完了後、監視を止めたい場合
                  if(yearMenu[i]){
                    yearMenu.forEach((menu) => {
                      menu.classList.remove("is-active")
                    })
                    yearMenu[i].classList.add("is-active")
                  }else{

                  }


              }
          });
      };
      const observer = new IntersectionObserver(callback, option); // callback, optionを設定
      observer.observe(dot); // 監視を開始
    })



    $(function(){
      // #で始まるa要素をクリックした場合に処理（"#"←ダブルクォーテンションで囲むのを忘れずに。忘れるとjQueryのバージョンによっては動かない。。）
      $('a[href^="#"]').click(function(){
        // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
        if (window.matchMedia('(min-width: 768px)').matches) {
          /* ウィンドウサイズ668以下の処理を記述 */
          var adjust = -200;
        }else{
          var adjust = -80;
        }

        // スクロールの速度（ミリ秒）
        var speed = 300;
        // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
        var href= $(this).attr("href");
        // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
        var target = $(href == "#" || href == "" ? 'html' : href);
        // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
        var position = target.offset().top + adjust;
        // スムーススクロール linear（等速） or swing（変速）
        $('body,html').animate({scrollTop:position}, speed, 'swing');


        setTimeout(() => {
          $(this).parent().addClass("is-active");
          $('a[href^="#"]').not(this).parent().removeClass("is-active");
        }, 500);

        return false;



      });
    });


  }
}

class Qa {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const modalTriggers = document.querySelectorAll(".js-modal-trigger")
    const modalContents = document.querySelectorAll(".js-qa-modal")
    const modalCloseBtns = document.querySelectorAll(".js-qa-modal-close")
    const modalOverlay = document.querySelector(".js-qa-modal-overlay")
    const body = document.querySelector("body")
    modalTriggers.forEach((trigger,i) => {

      trigger.addEventListener("click", () => {
        modalContents[i].classList.add("is-active")
        modalOverlay.classList.add("is-active")
        body.classList.add("is-scroll")
      })

      modalCloseBtns[i].addEventListener("click", () => {
        modalContents[i].classList.remove("is-active")
        modalOverlay.classList.remove("is-active")
        body.classList.remove("is-scroll")
      })

      modalOverlay.addEventListener("click", () => {
        modalContents[i].classList.remove("is-active")
        modalOverlay.classList.remove("is-active")
        body.classList.remove("is-scroll")
      })
    })

  }
}

class Single {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const listTxtWrap = document.querySelectorAll(".js-single-list-txt")




    listTxtWrap.forEach(txtWrap => {
      const txt = txtWrap.querySelectorAll("p")
      txt.forEach(ele => {

        if(!ele.textContent.match(/\S/g)){
          ele.classList.add("is-space")
        }

      })
    })


  }
}

//noScroll
class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){


  const mvAnimation = () => {
    let tl = gsap.timeline({repeat: 0, repeatDelay: 0.2});
    const num = 0.6

    tl.fromTo(".mv-left__swiper-01", 3 * num,
      {
        autoAlpha: 0,


      }, {
        autoAlpha:1,

      }
    );
    tl.fromTo('.mv-left__swiper-04', 3 * num, {
      autoAlpha: 0,
    },
    {
      autoAlpha:1,
    },
    `-=${3 * num}`
    );
    tl.fromTo(".mv-left__swiper-02", 2 * num,
      {
        autoAlpha: 0,


      }, {
        autoAlpha:1,

      },
      `-=${2 * num}`
    );
    tl.fromTo('.mv-left__swiper-05', 2 * num, {
      autoAlpha: 0,
    },
    {
      autoAlpha:1,
    },
    `-=${2 * num}`
    );
    tl.fromTo(".mv-left__swiper-03", 1 * num,
      {
        autoAlpha: 0,


      }, {
        autoAlpha:1,

      },
      `-=${num}`
    );
    tl.fromTo('.mv-left__swiper-06', num, {
      autoAlpha: 0,
    },
    {
      autoAlpha:1,
    },
    `-=${num}`
    );
    tl.fromTo('.js-mv-swiper', 3 * num, {
      autoAlpha: 0,
    },
    {
      autoAlpha:1,
    },
    `-=${3 * num}`
    );
    tl.fromTo(".js-mv-ttl", 1.6 * num,
    {
      autoAlpha: 0,
    }, {
      autoAlpha:1,
    },
    `-=${0.3 * num}`
  );


  }

  const topSwiper = () => {

    /****************************************
    MVスライダー 右画像
   ****************************************/

    // const swiperMv = new Swiper(".mv-swiper", {
    //   loop: true,
    //   slidesPerView: "auto",
    //   speed: 1000,
    //   allowTouchMove: false,
    //   autoplay: {
    //     delay: 4000,
    //   },
    // });

    for (let i = 1; i <= 6; i++) {
      var random = Math.floor( Math.random() * (10 - 1) ) + 1 * i;

      setTimeout(() => {
        const swiperSlideMv = new Swiper(`.mv-left__swiper-0${i}`, {

          effect: 'fade',
          loop: true,
          slidesPerView: "auto",
          speed: 1500,
          allowTouchMove: false,
          // effect: 'fade',
          autoplay: {
            delay: 2500,
          },
        });
      }, random * i * 120 - 3 );


    }



    const mvEnvSwiper = new Swiper(".env-swiper", {
      loop: true,
      slidesPerView: "auto",
      speed: 1000,
      allowTouchMove: false,
      centeredSlides : true,
    });

    if (window.matchMedia('(max-width: 768px)').matches) {
      const memberSwiper = new Swiper(".member-swiper", {
        loop: true,
        slidesPerView: "auto",
        speed: 1000,
        spaceBetween: 24,
        // allowTouchMove: false,

        // centeredSlides : true,
        autoplay: {
          delay: 4000,
        },
        pagination: {
          el: ".swiper-pagination", // ページネーションのクラス名を指定
          type: "fraction", // ページネーションのtypeを指定
          formatFractionCurrent: function (number) {
            return '0' + number;
        },
        formatFractionTotal: function (number) {
          return ('0' + number).slice(-2); // 先頭に0をつける、二桁表示
        },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  }

  const topMsgScroll = () => {

    const msgBg = document.querySelector(".msg-bg")
    let percentage = 0

    gsap.to(msgBg,
    {
      scrollTrigger: {
        trigger: '.js-msg-scroll',
        pin: true, // trigger要素を固定
        scrub: true,
        ease:'none',
        start: 'top',
        end:'bottom+=100 top',
        onUpdate:(self)=>{

          if(percentage < 100){
            percentage = self.progress.toLocaleString( undefined, { maximumFractionDigits:3 })*100;


            if (window.matchMedia('(min-width: 1600px)').matches) {
              if((96 + 50 / 100 * percentage) / 120 <= 1.01){
                msgBg.style.transform = `scale(calc((96 + 50 / 100 * ${percentage}) / 120))`
                msgBg.style.maxHeight = "1000px"
              }
            }else{
              if((96 + 50 / 100 * percentage) / 120 <= 1.03){
                msgBg.style.transform = `scale(calc((96 + 50 / 100 * ${percentage}) / 120))`
              }
            }


          }
        },
        onLeave: () => {
          msgBg.style.transform = `scale(1.02)`
        },
        // markers:true,
      }
    });
  }

  const getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min) + min);
  }

  const ScrollAnimation = {
    instance: undefined,
    set() {
      this.instance = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if(entry.isIntersecting) {
              entry.target.classList.add('is-active');
            }
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0,
        }
      );

      const blocks = document.querySelectorAll('.title');
      blocks.forEach((block) => {
        this.instance.observe(block);
      });
    },
  };

  const SplitText = (target) => {
    const splitElm = document.querySelectorAll(target);
    splitElm.forEach((el, index) => {
      let text = el.textContent;
      el.textContent = '';
      text = text.split('');
      let newText = '';
      text.forEach((t, index) => {
        newText += `<span class="word" data-random="${getRandomInt(1, 8)}">${t}</span>`;
      });
      el.insertAdjacentHTML('beforeend', newText);
    });
  };

  const memberHov = () => {
    const members = document.querySelectorAll(".js-member-hov")

    members.forEach( (member, i) => {
      member.addEventListener("mouseover", () => {
        member.classList.add("is-active")
      })
      member.addEventListener("mouseleave", () => {
        member.classList.remove("is-active")
      })
    });
  }


  SplitText('.text-split');
  ScrollAnimation.set();

  mvAnimation()


  setTimeout(() => {
    topSwiper()
  }, 300);

  if (window.matchMedia('(min-width: 768px)').matches) {
    topMsgScroll()
    memberHov()
  }

  const breakpoint = window.matchMedia("(max-width:768px)");

  breakpoint.addEventListener("change", () => {
    window.location.reload();
  });

  // memberModal();


  }


}

class Work {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const points = document.querySelectorAll(".js-point")
    const menuList = document.querySelectorAll(".js-menu-inview");

    // 対象のエレメント
    // optionは省略可能、初期値は以下のようになります。
    const option = {
        root: null,
        rootMargin: "-100px",
        threshold: [0]
    };

    points.forEach((dot,i) => {
      // 交差した際の処理を記載
      const callback = function (entries, observer) {
          entries.forEach(function (entry) {
              // 交差している場合はtrue
              if (entry.isIntersecting) {
                  // 処理実行
                  // 処理完了後、監視を止めたい場合
                  if(menuList[i]){
                    menuList.forEach((menu) => {
                      menu.classList.remove("is-inview")
                    })
                    menuList[i].classList.add("is-inview")
                  }
              }
          });
      };
      const observer = new IntersectionObserver(callback, option); // callback, optionを設定
      // Polyfillを使っている場合コメントアウトを外す
      // observer.POLL_INTERVAL = 100;
      observer.observe(dot); // 監視を開始
    })

    $(function(){
      // #で始まるa要素をクリックした場合に処理（"#"←ダブルクォーテンションで囲むのを忘れずに。忘れるとjQueryのバージョンによっては動かない。。）
      $('a[href^="#"]').click(function(){
        // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
        var adjust = -30;
        // スクロールの速度（ミリ秒）
        var speed = 400;
        // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
        var href= $(this).attr("href");
        // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
        var target = $(href == "#" || href == "" ? 'html' : href);
        // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
        var position = target.offset().top + adjust;
        // スムーススクロール linear（等速） or swing（変速）
        $('body,html').animate({scrollTop:position}, speed, 'swing');
        return false;
      });
    });

    const SwiperAll = document.querySelectorAll(".work-swiper")


    for (let i = 1; i <= SwiperAll.length; i++) {
      const swiper = new Swiper(`.work-swiper-0${i}`, {
        // ページネーションが必要なら追加
        allowTouchMove: false,
        speed: 800,
        loop: true,
        autoplay: {
          delay: 3000 + (i * 300) ,
        },
        pagination: {
          el: `.swiper-pagination-0${i}`
        },

      });
    }



  }
}

class AccordionEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if (window.matchMedia('(max-width: 768px)').matches) {
      //クリックで動く
      $('.nav-open').click(function(){
        $(this).toggleClass('is-active');
        $(this).next('div').slideToggle();
      });

    }

    const aboutAcc = document.querySelector(".js-about-acc")

    if(aboutAcc){
      //クリックで動く
      $('.js-about-trigger').click(function(){
        $(this).toggleClass('is-active');
        $(this).next().slideToggle(300);
      });
    }

    const careerAcc = document.querySelector(".js-career-acc")

    if(careerAcc){

      if (window.matchMedia('(max-width: 768px)').matches) {
        //クリックで動く
        $('.js-box-02-acc').click(function(){
          $(this).toggleClass('is-active');
          $(this).find('.item-txt').slideToggle();
        });

      }

    }

  }
}

var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class Counter {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

const countAll = document.querySelectorAll(".js-count-box")



for (let i = 1; i <= countAll.length; i++) {
  $(`.js-count-box-${i}`).on('inview', function(event, isInView) {

    $(this).addClass("is-active");

    if (isInView) {
      $(`.js-count-box-${i} .count-up`).each(function(){
        if(!$(this).hasClass("inview-counter")){
          $(this).prop('Counter',0).animate({//0からカウントアップ
            Counter: $(this).text()
          }, {
            // スピードやアニメーションの設定
            duration: 1500,//数字が大きいほど変化のスピードが遅くなる。2000=2秒
            easing: 'swing',//動きの種類。他にもlinearなど設定可能
            step: function (now) {
              $(this).text(Math.ceil(now));
            }
          });
          $(this).addClass("inview-counter");
        }
      });
      //要素が見えたときに実行する処理
    }
  });

}


  }
}


class FooterEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    // const footerNoInfo = document.querySelector(".js-no-footer-info")

    // if(footerNoInfo){

    //   const footerInfo = document.querySelector(".js-l-footer__info")
    //   footerInfo.classList.add("is-hidden")

    // }

    const footerNoLine = document.querySelector(".js-no-footer-line")

    if(footerNoLine){
      const footer = document.querySelector(".js-footer")
      footer.classList.add("is-noLine")
    }

    const footerNoEntry = document.querySelector(".js-no-footer-entry")

    if(footerNoEntry){
      const footerEntry = document.querySelector(".info-entry")

      if(footerEntry){
        footerEntry.classList.add("is-hidden")
      }
    }

  }
}

class HeaderEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const body  = document.querySelector("body")

    const megaMenuArea = document.querySelector(".mouse-action-area")

    // メガメニュー hover開閉
    const megaMenuTriggerAll = document.querySelectorAll(".js-mega-trigger")
    const megaMenuAll = document.querySelectorAll(".js-megaMenu")
    const menuOverlayAll = document.querySelectorAll(".mega-overlay")

    megaMenuArea .addEventListener("mouseover", () => {
      megaMenuAll.forEach(menu => {
        menu.classList.remove("is-hover")
        body.classList.remove("is-scroll")

        megaMenuTriggerAll.forEach(trigger => {
          trigger.classList.remove("is-hover")
        })
      })

    })

    megaMenuTriggerAll.forEach((menu, i) => {
      menu.addEventListener("mouseover", () => {

        body.classList.add("is-scroll")

        megaMenuAll.forEach(item => {
          item.classList.remove("is-hover")
        })

        megaMenuTriggerAll.forEach(item => {
          item.classList.remove("is-hover")
        })

        menu.classList.add("is-hover")

        if(megaMenuAll[i]){
          megaMenuAll[i].classList.add("is-hover")
        }

        if(megaMenuTriggerAll.length === (i + 1)){
          body.classList.remove("is-scroll")
        }

      })



    })

    menuOverlayAll.forEach((overlay, i) => {
      overlay.addEventListener("mouseover", () => {

        body.classList.remove("is-scroll")
        megaMenuAll[i].classList.remove("is-hover")
        megaMenuTriggerAll[i].classList.remove("is-hover")
      })

    })


    if (window.matchMedia('(max-width: 768px)').matches) {
      // ハンバーガーメニュー
      const menuTrigger = document.querySelector(".menu-trigger")
      const menuContainer = document.querySelector(".menu-container")
      const menuOverlay = document.querySelector(".menu-overlay")


      menuTrigger.addEventListener("click", () => {
        body.classList.toggle("is-scroll")
        menuContainer.classList.toggle("is-active")
        menuOverlay.classList.toggle("is-active")
        menuTrigger.classList.toggle("is-active")

      })

      menuOverlay.addEventListener("click", () => {

        body.classList.remove("is-scroll")
        menuContainer.classList.remove("is-active")
        menuOverlay.classList.remove("is-active")
        menuTrigger.classList.remove("is-active")
      })
    }


    const header = document.querySelector(".js-header")
    const menuTrigger = document.querySelector(".menu-trigger")

    window.addEventListener('scroll', (event) => {
      let scroll_y = window.scrollY;

      if(0 < scroll_y){
        header.classList.add("no-top")
        menuTrigger.classList.add("no-top")
      }else{
        header.classList.remove("no-top")
        menuTrigger.classList.remove("no-top")
      }

    });

  }
}

//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class MenberModal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const memberModal = () => {
      //TOP トリガー
      const memberCards = document.querySelectorAll(".js-member-hov")
      //メガメニュー
      const memberMageMenu = document.querySelectorAll(".js-mega-modal-trigger")
      //ハンバーガーメニュー
      const memberHamMenu = document.querySelectorAll(".js-ham-trigger")
      //フッターメニュー
      const memberFooterMenu = document.querySelectorAll(".js-footer-trigger")

      const modal = document.querySelector(".top-modal");
      const modalItem = document.querySelector(".top-modal__item")
      const modalClose = document.querySelector(".top-modal__close")
      const modalOverlay = document.querySelector(".top-modal__overlay")
      const path =  modalItem.getAttribute('src');


      const triggerElements = [
        memberCards,
        memberMageMenu,
        memberHamMenu,
        memberFooterMenu
      ]

      triggerElements.forEach(ele => {

        ele.forEach((card, i) => {
          card.addEventListener("click", () => {
            modal.classList.add("is-active")

            console.log(path);
            modalItem.setAttribute('src', `${path}/member-0${i + 1}.mp4`);
          })
        })

      })


      modalClose.addEventListener("click", () => {
        modal.classList.remove("is-active")
        modalItem.pause();
      })
      modalOverlay.addEventListener("click", () => {
        modal.classList.remove("is-active")
        modalItem.pause();
      })
    }

    const noLoad = () => {
      const noEventAll = document.querySelectorAll(".no-event")
      noEventAll.forEach(noEvent => {
        noEvent.addEventListener("click", function (event) {
          event.preventDefault();
        });
      })
    }


    memberModal();
    noLoad();

  }
}

class ModalEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const brandModalTrigger = document.querySelector(".js-brand-trigger")
    const brandModalContent = document.querySelector(".js-brand-modal")
    const brandModalOverlay = document.querySelector(".modal-overlay")
    const brandModalClose = document.querySelector(".modal-close")
    const body = document.querySelector("body")

    const closeEleAry = [
      brandModalOverlay,
      brandModalClose
    ]

    if(brandModalTrigger){

      brandModalTrigger.addEventListener("click", () => {
        brandModalContent.classList.add("is-active")
        body.classList.add("is-scroll")
      })

      closeEleAry.forEach(el => {
        el.addEventListener("click", () => {
          brandModalContent.classList.remove("is-active")
          body.classList.remove("is-scroll")
        })
      })

    }


  }
}

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}
class SlideEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

      // キャリア・研修制度
      const careerSwiper = document.querySelector(".model-step-swiper")

      if(careerSwiper){
        const careerStepSwiper = new Swiper(careerSwiper, {
          slidesPerView: "auto"/* この行を追加 */,
          spaceBetween: 30,
          // ページネーションが必要なら追加
          pagination: {
            el: ".swiper-pagination"
          },

          // ナビボタンが必要なら追加
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          breakpoints: {
            769: {
              spaceBetween: 60,
            },

          },
        });
      }

  }
}

class SplitAnimation {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const text = new SplitType(".split-target");
    
    gsap.to(".char", {
      y: 0 /*テキストのY軸の操作*/,
      stagger: 0.05 /*テキスト間の遅延時間*/,
      delay: 0.2 /*アニメーションのスタートまでの遅延時間*/,
      duration: 0.5 /*アニメーションの時間*/,
      // ease: power2.out /*イージングの設定*/,
    });
  }
}

class TextEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const getRandomInt = (min, max) => {
      return Math.floor(Math.random() * (max - min) + min);
    }

    const ScrollAnimation = {
      instance: undefined,
      set() {
        this.instance = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if(entry.isIntersecting) {
                entry.target.classList.add('is-active');
              }
            });
          },
          {
            root: null,
            rootMargin: '0px',
            threshold: 0,
          }
        );

        const blocks = document.querySelectorAll('.title');
        blocks.forEach((block) => {
          this.instance.observe(block);
        });
      },
    };

    const SplitText = (target) => {
      const splitElm = document.querySelectorAll(target);
      splitElm.forEach((el, index) => {
        let text = el.textContent;
        el.textContent = '';
        text = text.split('');
        let newText = '';
        text.forEach((t, index) => {
          newText += `<span class="word" data-random="${getRandomInt(1, 8)}">${t}</span>`;
        });
        el.insertAdjacentHTML('beforeend', newText);
      });
    };

    SplitText('.text-split');
    ScrollAnimation.set();


    
  }
}

class TopBack {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){    
    const topBackTrigger = document.querySelector(".js-top-back")

    topBackTrigger.addEventListener("click", () => {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    })
  }
}



(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let top = new Top('p-top');
  let history = new History('p-history');
  let qa = new Qa('p-qa');
  let single = new Single('p-single');
  let work = new Work('p-work');
  let accordionEvent = new AccordionEvent('js-acc');
  let menberModal = new MenberModal('js-menber-modal');
  let modalEvent = new ModalEvent('js-brand-modal');
  let slideEvent = new SlideEvent('js-slide');
  let topBack = new TopBack('js-top-back');
  let headerEvent = new HeaderEvent('js-header');
  let footerEvent = new FooterEvent('js-footer');
  let splitAnimation = new SplitAnimation('split-target');
  let textEvent = new TextEvent('js-text-event');
  let counter = new Counter('js-counter');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });